import { Cancel } from "@mui/icons-material";
import { Chip, Stack } from "@mui/material";
import React from "react";

const PreviewerChip = ({
  fileReaderContent,
  setFileReaderContent,
  onChange,
}) => {
  return (
    <React.Fragment>
      {fileReaderContent.fileName !== "" && (
        <React.Fragment>
          <Stack dir="ltr" alignItems="center">
            <Chip
              color="secondary"
              onDelete={() => {
                setFileReaderContent({
                  fileName: "",
                  fileContent: "",
                });
                onChange("");
              }}
              deleteIcon={<Cancel onMouseDown={(e) => e.stopPropagation()} />}
              label={fileReaderContent.fileName}
            />
          </Stack>
          <img
            style={{ borderRadius: "10px", width: "50%", height: "50%" }}
            src={fileReaderContent.fileContent}
            alt="preview"
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default PreviewerChip;
